// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__4ut2T","inner":"Footer_inner__37xab"};